<script>
    import Time from 'svelte-time';
</script>

<footer class="text-muted py-3 bg-light mt-5">
    <div class="container-fluid clearfix">
        <small class="float-end">
            <span class="fas fa-copyright"></span> WPFA <Time timestamp="{new Date()}" format="YYYY"/>
        </small>
        <img src='/images/wpfa-logo-primary.png' class="wp-logo rounded shadow-sm float-start me-3" alt="WPFirstaid"/> 
        <span class='text-muted'>
            Workplace First Aid Training
        </span>
    </div>
</footer>

<style>
    .wp-logo {
        width: 60px;
        height: auto;
        background: #000;
        padding: 4px; 
    }
</style>
